<template>
  <div class="uk-grid uk-margin-bottom uk-margin-top">
    <div class="uk-text-center uk-width-1-1 uk-margin-bottom">
      <h1>All done!</h1>
    </div>

    <div class="uk-width-1-1 uk-text-center">
      <a
        class="uk-button uk-width-1-1 button--cart"
        @click="closeAction"
        v-html="closeText"
      />
    </div>
    <div
      v-if="!event.data.deadline_submissions_passed"
      class="uk-width-1-1 uk-text-center"
    >
      <a
        class="uk-button uk-button-primary uk-width-1-1 uk-margin-top"
        @click="triggerNewEntry"
      >
        {{ $t('events.add_another_entry') }}
      </a>
    </div>
    <div class="uk-width-1-1 uk-margin-top uk-text-center">
      <a
        class="uk-button uk-button-link"
        @click="$emit('step-back')"
      >{{ $t('events.previous_step') }}</a>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import FormStep from "./FormStep";
import EventEntryModel from "../../models/EventEntryModel";
import EventModel from "../../models/EventModel";

@Component
export default class FinishedStep extends FormStep {
  @Prop() readonly entry!: EventEntryModel;

  triggerNewEntry(): void {
    this.$emit('close');
    this.$emit('create-entry');
  }

  get event(): EventModel {
    return this.$store.getters['events/byId'](this.entry.data.event_id);
  }

  get closeText(): string {
    return this.entry.isUnpaid() && !this.entry.isWithdrawn() ? '<span class="uk-icon-credit-card"></span> ' + <string>this.$t('events.close_form_and_pay') : <string>this.$t('events.close_window')
  }

  closeAction(): void {
    if (this.entry.isUnpaid() && !this.entry.isWithdrawn()) {
      this.$store.dispatch('events/cart/showCart', true);
    }
    this.$emit('close');
  }
}
</script>

<style scoped>
.button--cart {
  background: #FFB121;
  color: #3A2500;

  span {
    transform: rotate(-15deg);
  }
}
</style>
